import FormByType from './by_type'

export default {
  FormByType
}
